import { hasPublicInfo } from "@/config/radrootConfig";
import { useScrolled, scrollToAnchor } from "./primitives";

export default function Header() {
  const scrolled = useScrolled(24);

  const links = [
    { href: "#about", label: "About", tid: "nav-about-link" },
    { href: "#infrastructure", label: "Infrastructure", tid: "nav-infra-link" },
  ];
  if (hasPublicInfo())
    links.push({ href: "#public-info", label: "Radroot Provider Information", short: "Provider Info", tid: "nav-public-info-link" });

  return (
    <header className={`hdr ${scrolled ? "scrolled" : ""}`} data-testid="site-header">
      <div className="wrap hdr-in">
        <a
          href="#top"
          className="brand"
          data-testid="nav-brand-link"
          onClick={(e) => scrollToAnchor(e, "#top")}
          aria-label="Radroot — back to top"
        >
          <img src="/logo-wordmark.png" alt="Radroot" className="brand-wordmark" />
        </a>
        <nav className="nav" aria-label="Primary">
          {links.map((l) => (
            <a key={l.href} href={l.href} data-testid={l.tid} onClick={(e) => scrollToAnchor(e, l.href)}>
              {l.short ? (
                <>
                  <span className="nav-long">{l.label}</span>
                  <span className="nav-short">{l.short}</span>
                </>
              ) : (
                l.label
              )}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}
